// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 21/08/2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET ALL COLLECTION DETAILS START *********************** */
export const allCollectionDetailsGet = (listData: any) => {
	const data = {
		GetAllCollectionDetailsToken: listData,
	};
	const url = `${API_URL}getAllCollectionDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL COLLECTION DETAILS END *********************** */

/** ***************** GET BRANCH EOD WALLET DETAILS START *********************** */
export const BranchEODWalletDetailsGet = (listData: any) => {
	const data = {
		GetEODWalletAmountDetailsToken: listData,
	};
	const url = `${API_URL}getBranchEODWalletAmountDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET BRANCH EOD WALLET DETAILS END *********************** */

/** ***************** GET BRANCH EOD THRIFT DETAILS START *********************** */
export const BranchEODThriftDetailsGet = (listData: any) => {
	const data = {
		GetBranchEODThriftDetailsToken: listData,
	};
	const url = `${API_URL}getBranchEODThriftDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET BRANCH EOD THRIFT DETAILS END *********************** */

/** ***************** GET BRANCH EOD SAVINGS DETAILS START *********************** */
export const BranchEODSavingsDetailsGet = (listData: any) => {
	const data = {
		GetBranchEODSavingsDetailsToken: listData,
	};
	const url = `${API_URL}getBranchEODSavingsDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET BRANCH EOD SAVINGS DETAILS END *********************** */

/** ***************** GET BRANCH EOD YET TO COLLECT ARREAR DETAILS START *********************** */
export const BranchEODYetToCollectArrearDetailsGet = (listData: any) => {
	const data = {
		GetBranchEODYetToCollectArrearDetailsToken: listData,
	};
	const url = `${API_URL}getBranchYetToCollectMoveToArrear`;
	return makeApiCall(url, data);
};
/** ***************** GET BRANCH EOD YET TO COLLECT ARREAR DETAILS END *********************** */

/** ***************** GET DEMAND COLLECTION TOTAL DETAILS START *********************** */
export const DemandCollectionTotalDetailsGet = (listData: any) => {
	const data = {
		GetDemandCollectionTotalDetailsToken: listData,
	};
	const url = `${API_URL}getDemandCollectionTotalDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET DEMAND COLLECTION TOTAL DETAILS END *********************** */

/** ***************** GET ADVANCE COLLECTION TOTAL DETAILS START *********************** */
export const AdvanceCollectionTotalDetailsGet = (listData: any) => {
	const data = {
		GetAdvanceCollectionTotalDetailsToken: listData,
	};
	const url = `${API_URL}getAdvanceCollectionTotalDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET ADVANCE COLLECTION TOTAL DETAILS END *********************** */

/** ***************** GET ARREAR COLLECTION TOTAL DETAILS START *********************** */
export const ArrearCollectionTotalDetailsGet = (listData: any) => {
	const data = {
		GetArrearCollectionTotalDetailsToken: listData,
	};
	const url = `${API_URL}getArrearCollectionTotalDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET ARREAR COLLECTION TOTAL DETAILS END *********************** */

/** ***************** GET WALLET COLLECTION TOTAL DETAILS START *********************** */
export const WalletCollectionTotalDetailsGet = (listData: any) => {
	const data = {
		GetWalletCollectionTotalDetailsToken: listData,
	};
	const url = `${API_URL}getWalletCollectionTotalDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET WALLET COLLECTION TOTAL DETAILS END *********************** */

/** ***************** GET PRECLOSE COLLECTION TOTAL DETAILS START *********************** */
export const PrecloseCollectionTotalDetailsGet = (listData: any) => {
	const data = {
		GetPrecloseCollectionTotalDetailsToken: listData,
	};
	const url = `${API_URL}getPrecloseCollectionTotalDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET PRECLOSE COLLECTION TOTAL DETAILS END *********************** */

/** ***************** GET LOAN ADVANCE USED TOTAL DETAILS START *********************** */
export const LoanAdvanceUsedTotalDetailsGet = (listData: any) => {
	const data = {
		GetLoanAdvanceUsedTotalDetailsToken: listData,
	};
	const url = `${API_URL}getLoanAdvanceUsedTotalDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET LOAN ADVANCE USED TOTAL DETAILS END *********************** */

/** ***************** GET CLOSE LOAN LIST DETAILS START *********************** */
export const CloseLoanListDetailsGet = (listData: any) => {
	const data = {
		CloseLoanListFetchToken: listData,
	};
	const url = `${API_URL}fetchCloseLoanList`;
	return makeApiCall(url, data);
};
/** ***************** GET CLOSE LOAN LIST DETAILS END *********************** */

/** ***************** GET BRANCH EOD DETAILS START *********************** */
export const BranchEODDetailsGet = (listData: any) => {
	const data = {
		BranchEODFetchToken: listData,
	};
	const url = `${API_URL}getBranchEODDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET BRANCH EOD DETAILS END *********************** */

/** ***************** GET ACCOUNT DAY BOOK REPORT START *********************** */
export const accountDayBookReportGet = (listData: any) => {
	const data = {
		AccountDayBookPostDataToken: listData,
	};
	const url = `${API_URL}fetchAccountDayBook`;
	return makeApiCall(url, data);
};
/** ***************** GET ACCOUNT DAY BOOK REPORT END *********************** */

/** ***************** GET PRECLOSE COLLECTION DETAILS START *********************** */
export const PrecloseCollectionDetailsGet = (listData: any) => {
	const data = {
		GetPrecloseCollectionDetailsToken: listData,
	};
	const url = `${API_URL}getBranchPreCloseEODDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET PRECLOSE COLLECTION DETAILS END *********************** */

/** ***************** GET ADVANCE COLLECTION DETAILS START *********************** */
export const AdvanceCollectionDetailsGet = (listData: any) => {
	const data = {
		GetAdvanceCollectionDetailsToken: listData,
	};
	const url = `${API_URL}getBranchAdvanceCollectionEODDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET ADVANCE COLLECTION DETAILS END *********************** */

/** ***************** GET ARREAR COLLECTION DETAILS START *********************** */
export const ArrearCollectionDetailsGet = (listData: any) => {
	const data = {
		GetArrearCollectionDetailsToken: listData,
	};
	const url = `${API_URL}getBranchArrearCollectionEODDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET ARREAR COLLECTION DETAILS END *********************** */

/** ***************** GET VOUCHER APPROVED DETAILS START *********************** */
export const VoucherApprovedDetailsGet = (listData: any) => {
	const data = {
		GetVoucherApprovedDetailsToken: listData,
	};
	const url = `${API_URL}checkVoucherApproved`;
	return makeApiCall(url, data);
};
/** ***************** GET VOUCHER APPROVED DETAILS END *********************** */

/** ***************** GET SUBMIT EOD DETAILS START *********************** */
export const SubmitEODDetailsGet = (listData: any) => {
	const data = {
		GetSubmitEODDetailsToken: listData,
	};
	const url = `${API_URL}getEODLogetails`;
	return makeApiCall(url, data);
};
/** ***************** GET SUBMIT EOD DETAILS END *********************** */

/** ***************** GET REVERT EOD DETAILS START *********************** */
export const RevertEODDetailsGet = (listData: any) => {
	const data = {
		RevertEODSubmissionToken: listData,
	};
	const url = `${API_URL}revertEODSubmission`;
	return makeApiCall(url, data);
};
/** ***************** GET REVERT EOD DETAILS END *********************** */

/** ***************** GET EOD SAVINGS COLLECTION DETAILS START *********************** */
export const EODSavingsCollectionDetailsGet = (listData: any) => {
	const data = {
		GetParticularDateSavingsDetailToken: listData,
	};
	const url = `${API_URL}getMemberSavingsDetailsForParticularDate`;
	return makeApiCall(url, data);
};
/** ***************** GET EOD SAVINGS COLLECTION DETAILS END *********************** */

/** ***************** GET EOD GOLD COLLECTION DETAILS START *********************** */
export const EODGoldCollectionDetailsGet = (listData: any) => {
	const data = {
		GetGoldLoanCollectionEODDetailsToken: listData,
	};
	const url = `${API_URL}getGoldLoanCollectionEODDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET EOD GOLD COLLECTION DETAILS END *********************** */

export const EODStaffTravelDetailsGet = (listData: any) => {
	const data = {
		GetStaffTravelEODDetailsToken: listData,
	};
	const url = `${API_URL}getStaffTravelEODDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET EOD STAFF TRAVEL DETAILS END *********************** */

/** ***************** SUBMIT EOD STAFF TRAVEL DETAILS START *********************** */
export const SubmitEODStaffTravelDetailsPost = (listData: any) => {
	const data = {
		SubmitStaffTravelEODDetailsToken: listData,
	};
	const url = `${API_URL}updateStaffTravelEODDetails`;
	return makeApiCall(url, data);
};
/** ***************** SUBMIT EOD STAFF TRAVEL DETAILS END *********************** */
